import queryString from 'query-string';
import { rootDomain } from './env';

export default function getCheckoutPreviewUrl(
  page = {},
  seller = {},
  {
    isTesting = false,
    isTestingPayments = false,
    isPreview = false,
    variant,
    previewKey,
    isConfirmation = false,
    usePageId = false,
  } = {},
) {
  const pageUrlId = usePageId ? page._id : page.slug || page._id;
  const sellerUrlId = seller.name ? seller.name : seller._id;

  let checkoutUrl = `https://${sellerUrlId}.${rootDomain}/${pageUrlId}`;

  if (variant === 'site_embed' || variant === 'site_upsell_embed') {
    checkoutUrl = `https://${sellerUrlId}.${rootDomain}/embed/${pageUrlId}`;
  }

  if (variant === 'site_popup' || variant === 'site_upsell_popup') {
    checkoutUrl = `https://${sellerUrlId}.${rootDomain}/overlay/${pageUrlId}`;
  }

  if (variant === 'qr_code') {
    checkoutUrl = `https://${sellerUrlId}.${rootDomain}/${pageUrlId}/qr`;
  }

  if (isConfirmation) {
    checkoutUrl = `${checkoutUrl}/confirmation/${Math.random()}`;
  }

  return queryString.stringifyUrl({
    url: checkoutUrl,
    query: {
      ...(isTesting && { testing: true }),
      ...(isTestingPayments && { testingPayments: true }),
      ...(isPreview && { preview: true }),
      ...(previewKey && { previewKey }),
      ...((variant === 'hosted_upsell_page' ||
        variant === 'site_upsell_embed' ||
        variant === 'site_upsell_popup') && {
        upsell: true,
      }),
    },
  });
}
